export const PARTNUMBER_DELETE_OPEN_MODAL = "PARTNUMBER_DELETE_OPEN_MODAL";
export const PARTNUMBER_DELETE_REQUEST = "PARTNUMBER_DELETE_REQUEST";
export const PARTNUMBER_DELETE_RESULT = "PARTNUMBER_DELETE_RESULT";
